import { TypographySmall } from '@talentmesh/ui/components/typography';
import { cn } from '@talentmesh/ui/lib/utils';
import { useCandidatesOverviewContext } from '../../Contexts/CandidatesOverviewContext/CandidatesOverviewContext';
import { AdvancedFilter } from '../../Models/AdvancedFilter';
import AdvancedFilterButton from '../Filter/AdvancedFilterButton';
import { CustomMenuItemWithValueProps } from '../Filter/CheckboxRow';
import HiringStatusFilterButton from '../Filter/HiringStatusFilterButton';
import StatusFilterButton from '../Filter/StatusFilterButton';
import AdvancedFilterTypes from '@/Models/AdvancedFilterTypes';
import ClearFiltersButton from '@/Pages/Candidates/components/ClearFiltersButton';
import UIStrings from '@/Utils/UIStrings';

function AdvancedFiltersToolbar() {
    const { advancedFilters, updateAdvancedFilter, resetAdvancedFilterByType, resetAdvancedFilter } =
        useCandidatesOverviewContext();

    const sortFilters = (a: AdvancedFilter, b: AdvancedFilter): number => {
        return a.name?.localeCompare(b?.name);
    };

    const mapFilter2MenuItem = (filter: AdvancedFilter): CustomMenuItemWithValueProps => {
        const { id, name, count, selected } = filter;
        return {
            id,
            menuItemLabel: `${name} (${count})`,
            selected,
            changeCallback: () => {
                updateAdvancedFilter({ ...filter, selected: !selected });
            },
        };
    };

    const getMenuItemsByFilterType = (
        filters: AdvancedFilter[],
        filterType: AdvancedFilterTypes,
    ): CustomMenuItemWithValueProps[] => {
        return filters
            .filter((x) => x.filterType === filterType)
            .sort(sortFilters)
            .map(mapFilter2MenuItem);
    };

    const countryMenuItems = getMenuItemsByFilterType(advancedFilters, AdvancedFilterTypes.Country);
    const educationLevelMenuItems = getMenuItemsByFilterType(
        advancedFilters,
        AdvancedFilterTypes.HighestLevelOfEducation,
    );
    const educationFieldMenuItems = getMenuItemsByFilterType(advancedFilters, AdvancedFilterTypes.FieldOfEducation);
    const jobTypeMenuItems = getMenuItemsByFilterType(advancedFilters, AdvancedFilterTypes.JobType);

    return (
        <div className="flex flex-row flex-wrap items-center gap-2">
            <TypographySmall
                className={cn('text-muted-foreground shrink-0 font-semibold')}
            >{`${UIStrings.Filter}:`}</TypographySmall>
            <StatusFilterButton />
            <HiringStatusFilterButton />
            {countryMenuItems.length > 0 && (
                <AdvancedFilterButton
                    label={UIStrings.Country}
                    menuItems={countryMenuItems}
                    resetCallback={() => resetAdvancedFilterByType(AdvancedFilterTypes.Country)}
                />
            )}
            {educationLevelMenuItems.length > 0 && (
                <AdvancedFilterButton
                    label={UIStrings.HighestLevelOfEducation}
                    menuItems={educationLevelMenuItems}
                    resetCallback={() => resetAdvancedFilterByType(AdvancedFilterTypes.HighestLevelOfEducation)}
                />
            )}
            {educationFieldMenuItems.length > 0 && (
                <AdvancedFilterButton
                    label={UIStrings.FieldOfEducation}
                    menuItems={educationFieldMenuItems}
                    resetCallback={() => resetAdvancedFilterByType(AdvancedFilterTypes.FieldOfEducation)}
                />
            )}
            {jobTypeMenuItems.length > 0 && (
                <AdvancedFilterButton
                    label={UIStrings.JobType}
                    menuItems={jobTypeMenuItems}
                    resetCallback={() => resetAdvancedFilterByType(AdvancedFilterTypes.JobType)}
                />
            )}
            <ClearFiltersButton data-cy="AdvancedFilterReset" onClick={resetAdvancedFilter} />
        </div>
    );
}

export default AdvancedFiltersToolbar;
